import axios from '@/axios'

class CompanyMemberDataService {
  async getAllCompanyMembers(page: number): Promise<any> {
    return axios.get(`/companyMembers/getAllCompanyMembers?page=${page}`)
  }
  async getAllCompanyMembersForCompany(company_id: any): Promise<any> {
    return axios.get(`/companyMembers/${company_id}/getAll`)
  }
  async getCompanyMembersById(id: any): Promise<any> {
    return axios.get(`/companyMembers/${id}/get`)
  }
  async add(data: any): Promise<any> {
    return axios.post('/companyMembers/add', data)
  }
  async update(id: any, data: any): Promise<any> {
    return axios.put(`/companyMembers/${id}/update`, data)
  }
  async delete(id: any): Promise<any> {
    return axios.delete(`/companyMembers/${id}/delete`)
  }
  async getTypZakladatela(): Promise<any> {
    return axios.get('/companyMembers/getTypZakladatela')
  }
}
export default new CompanyMemberDataService()